import script from "./AppReviewAnalytics.vue?vue&type=script&setup=true&lang=js"
export * from "./AppReviewAnalytics.vue?vue&type=script&setup=true&lang=js"

import "./AppReviewAnalytics.vue?vue&type=style&index=0&id=ddd8af2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddd8af2e"]])

export default __exports__